export default [
  {
    path: '/vistoria/:vistoriaId/imovel-ambiente/:ambienteId/item-new',
    name: 'ItemCreate',
    component: () => import('./ImovelItensForm'),
    meta: {
      routerBack: '/vistoria/:vistoriaId/imovel-ambiente/:ambienteId/item',
      domain: 'Item',
      sidebar: false,
      title: 'Novo item',
      icon: 'keyboard_backspace',
    },
  },
  {
    name: 'Editar item',
    path: '/vistoria/:vistoriaId/item-edit/:id',
    meta: {
      sidebar: false,
      routerBack: '/vistoria/:vistoriaId/item',
      domain: 'Item',
      title: 'Editar item',
      icon: 'keyboard_backspace',
    },
  },
];



// WEBPACK FOOTER //
// ./src/app/Imovel/Vistoria/Ambiente/Itens/ItensForm/ItemFormRouter.js